<template>
  <vx-card :title="id === null ? 'Cadastrar Profissional' : 'Editar Profissional'">
    <!-- A API já calculava isso (GET /legal_entities/{id}/professional/checklist);
         só faltava alguma tela mostrar. -->
    <div class="mb-4" v-if="id && checklist.length">
      <b-alert :variant="checklistCompleto ? 'success' : 'warning'" show>
        <div class="alert-body">
          <p class="font-semibold mb-2">
            {{ checklistCompleto
              ? 'Cadastro completo — pronto para enviar para análise.'
              : 'Falta completar para enviar para análise:' }}
          </p>
          <ul class="mb-0 pl-4">
            <li v-for="item in checklist" :key="item.key">
              <feather-icon
                :icon="item.ok ? 'CheckCircleIcon' : 'CircleIcon'"
                :class="item.ok ? 'text-success' : 'text-warning'"
                size="14"
                class="mr-1 align-middle"/>
              <span :class="[item.ok ? 'text-muted' : '', item.ok ? '' : 'font-semibold']">{{ item.label }}</span>
            </li>
          </ul>
        </div>
      </b-alert>
    </div>
    <b-alert variant="secondary" show class="mb-4" v-if="isTabDisabled">
      <div class="alert-body">
        Salve os dados básicos abaixo para liberar as demais abas (endereço, telefone, dados
        bancários, modalidades e as outras) — elas dependem do cadastro já existir.
      </div>
    </b-alert>
    <vs-tabs :color="colorx" v-model="tabIndex">
      <vs-tab label="Dados Básicos">
        <ProfessionalForm ref="professionalForm"
                          :services="services"
                          :legalEntityId="id"
                          :professional="professional"
                          @update-data="handleUpdateData"></ProfessionalForm>
      </vs-tab>
      <vs-tab label="Endereço" :disabled="isTabDisabled">
        <Address :services="services" :people_id="professional.people_id" v-if="professional.people_id"/>
      </vs-tab>
      <vs-tab label="Região de atuação" :disabled="isTabDisabled">
        <ServiceArea :services="services"
                     :legalEntityId="professional.id"
                     :professional="professional"
                     @save-radius="saveRadius"
                     v-if="professional.id"/>
      </vs-tab>
      <vs-tab label="Telefone" :disabled="isTabDisabled">
        <Phone :services="services" :people_id="professional.people_id" v-if="professional.people_id"/>
      </vs-tab>
      <vs-tab label="Email" :disabled="isTabDisabled">
        <Email :services="services" :people_id="professional.people_id" v-if="professional.people_id"/>
      </vs-tab>
      <vs-tab label="Dados Bancários" :disabled="isTabDisabled">
        <Bank :services="services"
              :serviceDelegate="services.legalEntityService"
              :entityId="id"
              :people_id="professional.people_id"
              v-if="professional.people_id"/>
      </vs-tab>
      <vs-tab label="Modalidades" :disabled="isTabDisabled">
        <Modality :services="services"
                  :serviceDelegate="services.legalEntityService"
                  :people_id="professional.people_id"
                  :entityId="id"
                  v-if="professional.people_id"/>
      </vs-tab>
      <!-- Conselho de classe (CREF, CONFEF, CRN...). O componente já existia no
           cadastro de professor; aqui é o que vira o selo de credencial na página
           pública do profissional. -->
      <vs-tab label="Entidade de classe" :disabled="isTabDisabled">
        <ClassEntity :services="services"
                     :people_id="professional.people_id"
                     :teacherId="teacherId"
                     v-if="professional.people_id && teacherId"/>
        <b-alert variant="warning" show v-else-if="professional.people_id">
          <div class="alert-body">
            Este cadastro ainda não tem registro de professor associado, então não é
            possível informar o conselho de classe.
          </div>
        </b-alert>
      </vs-tab>
      <vs-tab label="Repasse (Stripe)" :disabled="isTabDisabled">
        <StripeConnect :legalEntityId="professional.id" v-if="professional.id"/>
      </vs-tab>
      <vs-tab v-if="canSeeBillingPlan" label="Plano de Cobrança" :disabled="isTabDisabled">
        <BillingPlan :legalEntityId="professional.id" v-if="professional.id"/>
      </vs-tab>
      <vs-tab label="Imagens" :disabled="isTabDisabled">
        <Images :serviceDelegate="services.legalEntityService"
                :people_id="professional.people_id"
                :entityId="professional.id"
                :imagesList="professional.images"
                target="legal_entities"
                hint="Tamanho recomendado: mínimo 1200×900px — fotos adicionais exibidas na galeria do perfil e ampliadas ao clicar."
                v-if="professional.people_id"/>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import FederationUnitService from '@/services/api/FederationUnitService'
import CityService from '@/services/api/CityService'
import LegalEntityService from '@/services/api/LegalEntityService'
import EmailTypeService from '@/services/api/EmailTypeService'
import AddressService from '@/services/api/AddressService'
import AddressTypeService from '@/services/api/AddressTypeService'
import EmailService from '@/services/api/EmailService'
import FinancialInstitutionService from '@/services/api/FinancialInstitutionService'
import BankDetailService from '@/services/api/BankDetailService'
import PhoneTypeService from '@/services/api/PhoneTypeService'
import PhoneService from '@/services/api/PhoneService'
import AreaCodeService from '@/services/api/AreaCodeService'
import ModalityService from '@/services/api/ModalityService'
import ClassEntityService from '@/services/api/ClassEntityService'
import TeacherService from '@/services/api/TeacherService'

import { BAlert } from 'bootstrap-vue'

import ProfessionalForm from '../tabs/ProfessionalForm'
import ServiceArea from '../tabs/ServiceArea'
import Address from '../tabs/Address'
import Email from '../tabs/Email'
import Bank from '../tabs/Bank'
import Phone from '../tabs/Phone'
import Modality from '../tabs/Modality'
import ClassEntity from '../tabs/ClassEntity'
import Images from '../tabs/Images'
import StripeConnect from '../tabs/StripeConnect'
import BillingPlan from '../tabs/BillingPlan'

export default {
  components: {
    ProfessionalForm,
    ServiceArea,
    Address,
    Email,
    Bank,
    Phone,
    Modality,
    ClassEntity,
    Images,
    StripeConnect,
    BillingPlan,
    BAlert,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    tabIndex: 0,
    teacherId: null,
    checklist: [],
    professional: {
      id: null,
      people_id: null,
      document: null,
      person_type: 'NE',
      trading_name: null,
      company_name: null,
      email: null,
      phone: null,
      birthdate: null,
      status: 'IR',
      kyc_status: 'PE',
      kyc_notes: null,
      description: null,
      logo_url: null,
      images: [],
      serves_in_person: true,
      serves_at_home: false,
      serves_online: false,
      service_radius_km: null,
    },
    services: {
      federationUnitService: null,
      cityService: null,
      legalEntityService: null,
      emailTypeService: null,
      addressService: null,
      addressTypeService: null,
      emailService: null,
      financialInstitutionService: null,
      bankDetailService: null,
      phoneTypeService: null,
      phoneService: null,
      areaCodeService: null,
      modalityService: null,
      classEntityService: null,
      teacherService: null,
    },
  }),
  methods: {
    loadData() {
      this.$vs.loading()
      this.services.legalEntityService.read(this.id).then(
        data => {
          this.professional = Object.assign({}, this.professional, data)
          // A API devolve o documento normalizado (só dígitos); a máscara do
          // formulário cuida da exibição.
          this.professional.document = data.document || data.cnpj
          this.professional.birthdate = this._.get(data, 'people.birthdate') || null
          this.$vs.loading.close()
          this.loadTeacherId()
          this.loadChecklist()
        },
        () => { this.$vs.loading.close() }
      )
    },
    loadChecklist(legalEntityId = this.id) {
      this.services.legalEntityService.getProfessionalChecklist(legalEntityId).then(
        data => { this.checklist = Array.isArray(data) ? data : [] },
        () => { this.checklist = [] }
      )
    },
    /**
     * O conselho de classe é gravado em /teachers/{id}/class_entities, então a aba
     * precisa do id do professor — não o do fornecedor. O cadastro do profissional
     * já cria esse registro (é o que permite a ele instruir as próprias aulas).
     */
    loadTeacherId() {
      this.services.legalEntityService.getAllTeachers(this.id).then(
        data => { this.teacherId = this._.get(data, '[0].id', null) },
        () => { this.teacherId = null }
      )
    },
    handleUpdateData(data) {
      const criandoAgora = !this.id
      this.professional = Object.assign({}, this.professional, data)
      this.professional.document = data.document || data.cnpj
      // create -> edit reaproveita esta mesma instância do componente (mesma
      // rota-componente): mounted() não roda de nova, então sem isto o
      // checklist ficava vazio até a próxima navegação manual.
      this.loadChecklist(data.id)
      if (criandoAgora) {
        this.$router.push(`/professionals/${data.id}/edit`)
      }
    },
    /**
     * O raio de atendimento mora na mesma linha de legal_entities dos Dados
     * Básicos — não tem endpoint de PATCH parcial, então salvar daqui reusa o
     * submit inteiro do formulário (já validado) em vez de duplicar a
     * montagem do payload.
     */
    saveRadius() {
      this.$refs.professionalForm.saveProfessionalForm()
    },
  },
  computed: {
    /** As demais abas dependem de people_id, que só existe depois de salvar. */
    isTabDisabled() {
      return this.id === null
    },
    // v-if (e não v-permission) porque a diretiva remove o nó no inserted e
    // confunde a contagem de abas do vs-tabs.
    canSeeBillingPlan() {
      return this.$acl.hasPermission('fee_plans.show')
    },
    checklistCompleto() {
      return this.checklist.length > 0 && this.checklist.every(item => item.ok)
    }
  },
  mounted() {
    if (this.id) {
      this.loadData()
    }
  },
  beforeMount() {
    this.services.federationUnitService = FederationUnitService.build(this.$vs)
    this.services.cityService = CityService.build(this.$vs)
    this.services.legalEntityService = LegalEntityService.build(this.$vs)
    this.services.emailTypeService = EmailTypeService.build(this.$vs)
    this.services.addressService = AddressService.build(this.$vs)
    this.services.addressTypeService = AddressTypeService.build(this.$vs)
    this.services.emailService = EmailService.build(this.$vs)
    this.services.financialInstitutionService = FinancialInstitutionService.build(this.$vs)
    this.services.bankDetailService = BankDetailService.build(this.$vs)
    this.services.phoneTypeService = PhoneTypeService.build(this.$vs)
    this.services.phoneService = PhoneService.build(this.$vs)
    this.services.areaCodeService = AreaCodeService.build(this.$vs)
    this.services.modalityService = ModalityService.build(this.$vs)
    this.services.classEntityService = ClassEntityService.build(this.$vs)
    this.services.teacherService = TeacherService.build(this.$vs)
  }
}
</script>
